import { useCallback } from "react";
import { toast } from "react-toastify";
import { Category } from "../models/Category";
import { getTabCount } from "../services/tabCountService";
import { showError } from "../services/utilities/ServiceError";
import { shouldUpdateCategory } from "../utilities/tabUtils";

interface UseTabCountProps {
    tableName: string;
    pathToSite?: string;
    categories: Category[];
    setCategories: React.Dispatch<React.SetStateAction<Category[]>>;
    customFilters?: { [key: string]: string };
}

export const useTabCount = (tabCountProps: UseTabCountProps) => {
    const showTabCount = window.sessionStorage.getItem("showTabCounts") === "1";
    
    if (!showTabCount) {
        // Make sure the empty updateTabCount matches the signature of the real one, so that React sees it as the same during renders.
        return { updateTabCount: useCallback(async () => { }, []) };
    }

    // This is the real one
    const updateTabCount = useCallback(
        async (siteIds: string[]) => {
            try {
                const tabCount = await getTabCount(tabCountProps.tableName, tabCountProps.pathToSite, siteIds, tabCountProps.customFilters);
                const categoryBadge = shouldUpdateCategory(tabCountProps.categories, tabCount.tabCount);

                if (categoryBadge.shouldUpdate && categoryBadge.categoryToUpdate) {
                    tabCountProps.setCategories([categoryBadge.categoryToUpdate]);
                }
            } catch (error) {
                showError(error, toast.warn);
            }
        },
        [tabCountProps.categories, tabCountProps.setCategories, tabCountProps.tableName, tabCountProps.pathToSite, tabCountProps.customFilters, toast],
    );

    return { updateTabCount };
};
